import { Icon } from '@iconify/react'
import clsx from 'clsx'
import { Tooltip } from '@pepper/ui'
import { pluralize } from '@pepper/utils/src/function/pluralize'
import { Domain } from '@pepper/utils/src/types/seo'

import DomainPill from 'components/DomainPill'

import s from './Option.module.css'

type Props = {
  title: string
  projectId: string
  itemsCount: number
  topicsCount?: number
  onClick: () => void
  domain?: Domain
  activeDomainId?: string
  isSelected?: boolean
}

export const Option = ({
  title,
  itemsCount,
  topicsCount,
  projectId,
  onClick,
  domain,
  activeDomainId,
  isSelected,
}: Props) => {
  const isDomainDeleted = !!domain?.deleted_at

  const isDisabled = () => {
    if (!activeDomainId) return isDomainDeleted

    return isDomainDeleted || activeDomainId !== domain?.id
  }

  const getTooltipTitle = () => {
    if (isDisabled()) {
      if (isDomainDeleted) {
        return 'Domain for this project is deleted'
      }
      return 'Project domain and selected domain do not match'
    }
  }

  return (
    <button
      className={clsx(s.wrapper, {
        [s.selected]: isSelected,
      })}
      onClick={onClick}
      disabled={isDisabled()}
      {...(isDomainDeleted && {
        title: 'Domain associated with this project has been deleted',
      })}
    >
      <Tooltip
        title={getTooltipTitle()}
        className={clsx(s.tooltip, s.wrapper, {
          [s.selected]: isSelected,
        })}
        arrowPointAtCenter={true}
      >
        <div className={s.left}>
          <Icon className={s.icon} icon="lucide:folder-closed" />
          <p className={s.title}>{title}</p>
          <p className={s.projectId}>#{projectId}</p>
          {domain && <DomainPill domain={domain} />}
        </div>

        <div className={s.right}>
          <div className={s.pill}>{pluralize(itemsCount, 'Item')}</div>
          {!!topicsCount && (
            <div className={s.pill}>{pluralize(topicsCount, 'Topic')}</div>
          )}
        </div>
      </Tooltip>
    </button>
  )
}
